// extracted by mini-css-extract-plugin
export default {"item":"FormItemBase_item__H9oSl","without-explain":"FormItemBase_without-explain__soA17","marginless":"FormItemBase_marginless__WtrBY"};